import { useCallback, useMemo } from 'react';
import { convertListToArray } from '../../shared/utils/immutable';
import { ensureChildTeamsAppearSelected, normalizeTeamSelections } from '../utils/select-teams';
export const useSelectUsersAndTeams = ({
  teamIds: selectedTeamIds,
  teams,
  userIds: selectedUserIds,
  optionIds
}) => {
  const teamIds = useMemo(() => Array.from(ensureChildTeamsAppearSelected(selectedTeamIds, teams)), [selectedTeamIds, teams]);
  const selectedIds = useMemo(() => teamIds.concat(convertListToArray(selectedUserIds)), [teamIds, selectedUserIds]);
  const onSelect = useCallback(({
    target
  }) => {
    const newUserIds = [];
    const newTeamIds = [];

    // TODO: need to investigate this to ensure we can't have a collision where a
    // team and a user could have the same ID
    for (const value of target.value) {
      if (optionIds.users.includes(value)) {
        newUserIds.push(value);
      } else if (optionIds.teams.includes(value)) {
        newTeamIds.push(value);
      }
    }
    const resolvedTeamIds = normalizeTeamSelections(teamIds, newTeamIds, teams);
    return {
      teamIds: resolvedTeamIds,
      userIds: newUserIds
    };
  }, [optionIds, teamIds, teams]);
  return {
    onSelect,
    selectedIds
  };
};